module.exports = __webpack_public_path__ + "media/startBlip.22d5be88.wav";